import { render, staticRenderFns } from "./CatalogMiniature.vue?vue&type=template&id=65951201&scoped=true"
import script from "./CatalogMiniature.vue?vue&type=script&lang=ts"
export * from "./CatalogMiniature.vue?vue&type=script&lang=ts"
import style0 from "./CatalogMiniature.vue?vue&type=style&index=0&id=65951201&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65951201",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
